module.exports = __webpack_public_path__ + "img/vertical_4_3_8011.147ecbcd.png";